import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';
import { LAO_BET_TYPE_LABELS } from '../../utils/laoUtils';

function statusMeta(bet) {
  if (bet.status === 'won') {
    return { text: 'ถูกรางวัล', className: 'bg-green-100 text-green-800', row: 'border-green-300 bg-green-50' };
  }
  if (bet.status === 'lost') {
    return { text: 'ไม่ถูก', className: 'bg-gray-100 text-gray-600', row: 'border-gray-100 bg-gray-50' };
  }
  return { text: 'รอผล', className: 'bg-amber-50 text-amber-700', row: 'border-amber-100 bg-amber-50/40' };
}

export function LaoMyBets({ bets }) {
  const rows = Array.isArray(bets) ? bets.slice(0, 12) : [];
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">โพยของฉัน</CardTitle>
      </CardHeader>
      <CardContent>
        {rows.length === 0 ? (
          <p className="text-sm text-gray-500">ยังไม่มีรายการแทงหวยลาว</p>
        ) : (
          <ul className="space-y-2">
            {rows.map((bet) => {
              const status = statusMeta(bet);
              return (
                <li
                  key={bet.id}
                  className={`flex items-center justify-between gap-3 rounded-xl border-2 px-3 py-2 text-sm ${status.row}`}
                >
                  <div>
                    <p className="font-mono text-lg font-bold text-brand-red">{bet.number}</p>
                    <p className="text-xs text-gray-500">
                      {bet.betTypeLabel || LAO_BET_TYPE_LABELS[bet.betType] || bet.betType} ·{' '}
                      {formatMoney(bet.amount)}
                    </p>
                  </div>
                  <div className="text-right">
                    <span className={`rounded-full px-2 py-1 text-xs font-semibold ${status.className}`}>
                      {status.text}
                    </span>
                    {bet.status === 'won' && Number(bet.payout) > 0 ? (
                      <p className="mt-1 text-xs font-bold text-green-700">
                        {formatMoney(bet.payout)}
                      </p>
                    ) : null}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
